export const setItem = (key: string, value: any): void => {
  localStorage.setItem(key, value);
};
export const getItem = (key: string): string | null =>
  localStorage.getItem(key);

export const removeItem = (key: string): void => localStorage.removeItem(key);

export const clearAllStorage = () => localStorage.clear();
